module.exports = __webpack_public_path__ + "static/media/pastor-benjamin.038b6716.jpg";